<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <div class="title">{{ title }}</div>
      <div class="aggreeWrap" v-html="content">
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          type="primary"
          :disabled="btnDisable"
          @click="goNext"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/*global protocol util http*/
import { mapGetters } from 'vuex'
export default {
  name: 'AgreementDialog',
  data() {
    return {
      btnDisable: false,
      time: 15,
      timeer: null,
      dialogVisible: false,
      content: ``,
      title: ''
    }
  },
  // commFormData --- localStorage里面
  // item --- vuex商品信息
  // setAnalogueMobileMes --- vuex里的数据，对手方账号
  computed: {
    ...mapGetters([
      'item',
      'setAnalogueMobileMes',
      'sessionInfoGetter',
      'systemTimeGetter'
    ])
  },
  mounted() {},
  methods: {
    /**
     * 启动dialog方法
     * @param {number} cms详情id 
     */
    showDialog(did) {
      this.dialogVisible = true
      window.clearInterval(this.timeer)
      protocol.param_getContentDetails.param.id = did
      http.getRes(protocol.param_getContentDetails).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.content = value.content
          this.title = value.title
        } else {
          this.$toast(message)
        }
      })

    },
    repeatString(str, n) {
      return new Array(n + 1).join(str)
    },
    goNext() {
      this.dialogVisible = false
      this.$emit('reLoad')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 1200px !important;
  height: initial !important;
  border-radius: 8px;
  margin-top: 7vh !important;
  .aggreeWrap {
    min-height: 350px;
    overflow-y: scroll;
    p {
      font-weight: 500;
      color: #d4d4d4;
      font-size: 16px;
      line-height: 26px;
      margin-right: 20px;
    }
  }
  .title {
      font-weight: 500;
      color: #d4d4d4;
      font-size: 20px;
      line-height: 40px;
      margin-right: 20px;
      text-align: center;
  }
  .checkStyle {
    padding-top: 10px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: 600;
    color: #d4d4d4;
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 0 40px;
  }
  .el-dialog__header {
    text-align: center !important;
    background-color: #2c2c2c !important;
    padding: 40px 40px 0 40px !important;
    border-radius: 8px 8px 0 0;
  }
  .el-dialog__body {
    background-color: #2C2C2C !important;
  }
  .el-dialog__headerbtn {
    top: 20px;
    right: 40px;
  }
  .el-dialog__footer {
     background-color: #2C2C2C !important;
    text-align: center;
    padding: 40px;
    border-radius: 0 0 8px 8px;
  }
  .el-button + .el-button {
    margin-left: 25px;
  }
  .el-button {
    padding: 10px 34px;
  }
  /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: transparent;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #dfdfdf;
    border-radius: 10px;
    background-color: transparent;
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #838383;
    background-color: #383f66;
  }
  .el-button--primary {
    span {
      color: #fff;
    }
  }
}
</style>
